import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import {Icon, Breadcrumb, Button, Steps, Badge, Popover, Avatar, Card} from 'antd';
import { GetEditionParams, GetMagazineParams } from '../../APIModels/ApiParamsIndex';
import { Edition } from '../../Models/ModelIndex';
import EditionService from '../../Services/editionService';
import MagazineService from '../../Services/magazineService';
import queryString from 'query-string';
import { HandleEditionRender } from './HandleEditionRender';
import { HandleEditionFileRender } from './HandleEditionFileRender';
import moment from 'moment';
import alertService from '../../Services/alertService';

const { Step } = Steps;

export class HandleEdition extends React.Component {
    constructor(props) {
        super(props)

        document.title = "Polar - Create edition"

        let params = queryString.parse(this.props.location.search);
        this.props.showUserBadge(false);
        this.state = {
            user: this.props.token,
            step: 0,
            edition: new Edition(),
            editionParam: new GetEditionParams(),
            magazineParam: new GetMagazineParams(),
            editionSaved: true,
            editions: [],
            magazines: [],
            activeMagazine: '',
            activeEdition: '',
            id: params.id,
            parentEditionClicked: ''
        }

        this.editionService = new EditionService(this.props.token);
        this.magazineService = new MagazineService(this.props.token);

        this.handleParent = this.handleParent.bind(this);
        this.focusParent = this.focusParent.bind(this);
        this.handleMagazine = this.handleMagazine.bind(this);
        this.goBack = this.goBack.bind(this);
        this.changeStep = this.changeStep.bind(this);
        this.handleNumberChange = this.handleNumberChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.editionNameWritten = this.editionNameWritten.bind(this);
        this.magazineNameWritten = this.magazineNameWritten.bind(this);
        this.fetchEditions = this.fetchEditions.bind(this);
        this.fetchEditionById = this.fetchEditionById.bind(this);
        this.fetchMagazine = this.fetchMagazine.bind(this);
        this.onCompetenceFromChange = this.onCompetenceFromChange.bind(this);
        this.onCompetenceToChange = this.onCompetenceToChange.bind(this);
        this.editEdition = this.editEdition.bind(this);
        this.saveEdition = this.saveEdition.bind(this);
        this.handleClear = this.handleClear.bind(this);
    }

    componentDidMount() {

        this.props.loader(true)
        this.props.loader(true)

        if (this.state.id)
            this.fetchEditionById(this.state.id);
        else {
            this.fetchEditions();
            this.fetchMagazine();
        }
    }

    fetchEditionById(id, skipCb = false) {
        this.props.loader(true)
        this.editionService.getEdition(id)
            .then((response) => {
                console.log(response.data)
                this.setState({ edition: response.data.data }, (() => this.callBack(skipCb)))
                this.props.loader(false)
            }).catch((err) => {
                console.log(err);
                this.props.loader(false)
            })
    }

    callBack(skipCb) {
        if (skipCb)
            return 

        this.fetchEditions();
        this.fetchMagazine();
    }

    fetchEditions() {

        this.editionService.getEditionList(this.state.editionParam)
            .then((response) => {
                let data = response.data.data;
                if (this.state.id && this.state.edition.parentEditionAttachmentTypeId) {
                    var activeEdition = data.filter(m => m.id == this.state.edition.parentEditionAttachmentTypeId)[0].number;
                    this.setState({ activeEdition: activeEdition, parentEditionClicked: activeEdition })
                    data = data.filter(m => m.id != this.state.id)
                }

                this.setState({ editions: data });
                this.props.loader(false)
            })
            .catch((err) => {
                console.log(err);
                this.props.loader(false)
            });
    }

    fetchMagazine() {
        this.magazineService.getMagazineList(this.state.magazineParam)
            .then((response) => {
                let data = response.data.data;
                if (this.state.id) {
                    var activeMagazine = data.filter(m => m.id == this.state.edition.magazineId)[0].name;
                    this.setState({ activeMagazine: activeMagazine })
                }
                this.setState({ magazines: data });
                this.props.loader(false)
            })
            .catch((err) => {
                console.log(err);
                this.props.loader(false)
            });
    }

    saveEdition() {
        this.props.loader(true)

        this.editionService.addEdition(this.state.edition)
            .then((response) => {
                if(response.data && response.data.ok){
                    alertService.setAlert('success', 'Edition add');
                    let edition = this.state.edition;
                    edition.id = response.data.data;

                    this.setState({ edition: edition, step: 1, id: edition.id });
                    this.props.loader(false)
                } else {
                    this.props.loader(false);
                }
            })
            .catch((err) => {
                console.log(err);
                this.props.loader(false)
            });
    }

    editEdition() {
        this.props.loader(true)

        this.editionService.updateEdition(this.state.edition)
            .then((response) => {
                if(response.data && response.data.ok){
                    alertService.setAlert('success', 'Edition update');
                    this.props.loader(false);
                    this.setState({ step: 1 });
                }
            })
            .catch((err) => {
                console.log(err);
                this.props.loader(false)
            });
    }

    goBack() {
        if(document.referrer) //exist prev url
            return window.history.back()
        else
            return window.open("/archive", '_self');
    }

    changeStep(value) {
        if(value === 2) //go to add articles
            window.open('/archive/articles/create?editionId=' + this.state.edition.id, '_self');
        else{
            this.setState({ step: value })
        }
    }

    handleParent(value) {
        let edition = this.state.edition;
        edition.parentEditionAttachmentTypeId = value;

        var activeEdition = this.state.editions.filter(e => e.id == value)[0].number;

        this.setState({ edition: edition, editionSaved: false, parentEditionClicked: activeEdition, activeEdition: activeEdition })
    }

    focusParent(){
        const active = this.state.parentEditionClicked;
        this.setState({activeEdition: active})        
     }

    handleMagazine(value) {
        let edition = this.state.edition;
        edition.magazineId = value;
        var activeMagazine = this.state.magazines.filter(e => e.id == value)[0].name;

        this.setState({ edition: edition, editionSaved: false, activeMagazine: activeMagazine })
    }

    editionNameWritten(value) {
        this.setState({ activeEdition: value });
    }

    magazineNameWritten(value) {
        this.setState({ activeMagazine: value });
    }

    handleNumberChange(event) {
        let edition = this.state.edition;
        edition.number = event.target.value;

        if (event.target.value.length === 0) {
            edition.number = null;
        }

        this.setState({ edition: edition, editionSaved: false });
    }

    handleDescriptionChange(event) {
        let edition = this.state.edition;
        edition.description = event.target.value;

        if (event.target.value.length === 0) {
            edition.description = null;
        }

        this.setState({ edition: edition, editionSaved: false });
    }

    onCompetenceFromChange = value => {
        let date = moment(value).utc().startOf('day');
        let edition = this.state.edition;
        edition.competenceDateFrom = date;

        this.setState({ edition: edition, editionSaved: false });
    };

    onCompetenceToChange = value => {
        let date = moment(value).utc().endOf('day');
        let edition = this.state.edition;
        edition.competenceDateTo = date;

        this.setState({ edition: edition, editionSaved: false });
    };

    handleClear(clear) {
        let edition = this.state.edition;
        if (clear == "magazine") {
            edition.magazineId = null;
            this.setState({ edition: edition, activeMagazine: '' });
        }
        else if (clear == "parentedition") {
            edition.parentEditionAttachmentTypeId = null;
            this.setState({ edition: edition, activeEdition: '' });
        }

    }

    render() {

        let prop = {
            editions: this.state.editions,
            magazines: this.state.magazines,
            edition: this.state.edition,
            disabledSaveButton: this.state.disabledSaveButton,
            editionSaved: this.state.editionSaved,
            activeMagazine: this.state.activeMagazine,
            activeEdition: this.state.activeEdition,
            parentEditionClicked: this.state.parentEditionClicked
        }

        let func = {
            handleMagazine: this.handleMagazine,
            handleParent: this.handleParent,
            focusParent: this.focusParent,
            editionNameWritten: this.editionNameWritten,
            handleNumberChange: this.handleNumberChange,
            handleDescriptionChange: this.handleDescriptionChange,
            onCompetenceFromChange: this.onCompetenceFromChange,
            onCompetenceToChange: this.onCompetenceToChange,
            editEdition: this.editEdition,
            saveEdition: this.saveEdition,
            handleClear: this.handleClear
        }

        return (
            <Container fluid={true}>
                <Row>
                    <Col sm="12" style={{display: 'inline-flex', height: '0', justifyContent: "end"}}>
                        <Breadcrumb className="bread" style={{left: 24}}>
                            <Breadcrumb.Item>
                                <Button className="fmk_button primary mr-2" style={{bottom: 3}} onClick={() => this.goBack()}>
                                    <Icon type="caret-left" />
                                </Button>
                                <strong className="h5 font-weight-bold" style={{color: 'black'}}>
                                    {this.state.id ? 'Edit': 'Create'} Edition
                                </strong>
                            </Breadcrumb.Item>

                        </Breadcrumb>
                        <div className="plusButtonCat">
                            <Badge>
                                <Popover placement="bottomRight" content={this.props.usercontent} trigger="click">
                                    <div style={{cursor: 'pointer'}}>
                                        <Avatar style={{backgroundColor: this.props.avatarColor, marginLeft: '5px'}}
                                                icon="user"/>
                                    </div>
                                </Popover>
                            </Badge>
                        </div>
                    </Col>

                    <Col sm="6" className="offset-3 mb-4 mt-4">
                        <Card className="fmk_card p-4 mt-0" style={{borderRadius: "6px"}}>
                            <Steps current={this.state.step} onChange={(this.state.id) ? this.changeStep : null}>
                                <Step title="Insert data" description="Data insert " icon={<Icon type="form" />} />
                                <Step title="Insert file" description="File insert" icon={<Icon type="file-add" />} />
                                <Step title="Insert article" description="Article insert" icon={<Icon type="file-add" />} />
                            </Steps>
                        </Card>
                    </Col>
                    {this.state.step == 0 ? (
                        <HandleEditionRender data={prop} func={func} />
                    ) : (
                        <HandleEditionFileRender user={this.state.user} edition={this.state.edition} loader={this.props.loader} fetchEditionById={this.fetchEditionById} />
                    )}

                </Row>
            </Container>  
        );
    }
}



// WEBPACK FOOTER //
// ./src/FileMaker/Editions/HandleEdition.js